import { render } from "./Industry.vue?vue&type=template&id=17513a62&scoped=true"
import script from "./Industry.vue?vue&type=script&lang=js"
export * from "./Industry.vue?vue&type=script&lang=js"

import "./Industry.vue?vue&type=style&index=0&id=17513a62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17513a62"]])

export default __exports__